import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { BASE_URL } from "./BaseUrl";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

const PlacementReport = () => {
    const [placementReportList, setPlacementReportList] = useState([]);

    useEffect(() => {
        getPlacementReport();
    }, []);

    const getPlacementReport = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/getPlacementData`);
            setPlacementReportList(response.data);
        } catch (err) {
            console.log(err);
        }
    };

    function formatDate(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const handleExportExcel = () => {
        if (!placementReportList || placementReportList.length === 0) {
            alert("No data to export");
            return;
        }

        // Map data for Excel
        const excelData = placementReportList.map((row) => ({
            "Training Program Name": row.Course_Name,
            "Batch Number": row.Batch_code,
            "Convocation Date": row.DateAdded ? formatDate(row.DateAdded) : "",
            "Pass Students": row.PassStudent ?? 0,
            "Self Placed": row.OwnPercentage ?? 0,
            "Total Interview": row.TotalInterview ?? 0,
            "Total Students in Batch": row.NoStudent ?? 0,
            "Students Placed": row.Placement ?? 0,
            "Placement %": row.NoStudent && row.Placement ? ((row.Placement / row.NoStudent) * 100).toFixed(2) + "%" : "0%"
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Placement Report");
        XLSX.writeFile(workbook, "Placement_Report.xlsx");
    };

    const columns = [
        { field: "Course_Name", headerName: "Training Program Name", width: 210 },
        { field: "Batch_code", headerName: "Batch Number", width: 120 },
        {
            field: "DateAdded",
            headerName: "Convocation Date",
            width: 100,
            renderCell: (params) => params.value && formatDate(params.value),
        },
        { field: "PassStudent", headerName: "Pass Students", width: 100 },
        { field: "OwnPercentage", headerName: "Self Placed ", width: 100 },
        { field: "TotalInterview", headerName: "Total Interview", width: 100 },
        { field: "NoStudent", headerName: "Total Students in Batch", width: 100 },
        { field: "Placement", headerName: "Students Placed", width: 100 },
        {
            field: "Sparkline",
            headerName: "Sparkline",
            width: 120,
            renderCell: (params) => {
                const { NoStudent, Placement } = params.row;
                const percentage = NoStudent && Placement ? (Placement / NoStudent) * 100 : 0;

                return (
                    <div
                        style={{
                            width: "100%",
                            height: "20px",
                            backgroundColor: "lightgray",
                        }}
                    >
                        <div
                            style={{
                                width: `${Math.min(percentage, 100)}%`,
                                height: "100%",
                                backgroundColor: "green",
                            }}
                        ></div>
                    </div>
                );
            },
        },
    ];

    return (
        <div className="row mt-4">
            <div className="col-8">
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Placement Report</h4>

                        {/* Export Button */}


                        <div className="custom-header">
                            <DataGrid
                                rows={placementReportList}
                                columns={columns}
                                rowHeight={35}
                                initialState={{
                                    pagination: {
                                        paginationModel: {
                                            pageSize: 10,
                                        },
                                    },
                                }}
                                sx={{
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        whiteSpace: "normal",
                                        lineHeight: "normal",
                                    },
                                    "& .MuiDataGrid-columnHeader": {
                                        height: "unset !important",
                                    },
                                    "& .MuiDataGrid-columnHeaders": {
                                        maxHeight: "175px !important",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                                        height: 5,
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                                        borderRadius: 10,
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
                                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
                                        background: "transparent",
                                    },
                                }}
                                getRowId={(row) => row.Batch_Id}
                                pageSizeOptions={[8]}
                                disableColumnFilter
                                disableColumnSelector
                                disableDensitySelector
                                disableColumnMenu
                            />
                        </div>
                        <button
                            onClick={handleExportExcel}
                            className=" btn btn-primary"
                            style={{ float: "right", }}
                        >
                            Export to Excel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlacementReport;
